import { CircularProgress } from '@mui/material'
import dynamic from 'next/dynamic'

interface IVideoStreamPlayerProps {
  mediaId?: string
  media_url: string
  poster?: string
  videoStyle?: any
  hideControls?: boolean
  autoPlay?: boolean
  preload?: 'auto' | 'metadata' | 'none'
}

const VideoStreamShakaPlayer = dynamic(
  () => import('./VideoStreamShakaPlayer'),
  {
    ssr: false,
    loading: () => (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress size={10} />
      </div>
    ),
  },
)

const VideoStreamPlayer = (props: IVideoStreamPlayerProps) => {
  return <VideoStreamShakaPlayer {...props} />
}

export default VideoStreamPlayer
